import { ReduxAction } from '../../constants';
const initialState = {};

const DbConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case ReduxAction.dbConfig: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
export default DbConfigReducer;
